<div class="text-center">
  <img
    src="/assets/img/PersonnelPulseLogo.png"
    style="max-height: 10vh; width: auto"
  />
  <h1 class="text-danger fw-bold">DEMO ACCOUNT</h1>
  <hr />
</div>

<ws-loading-indicator
  *ngIf="isLoading"
  class="d-flex justify-content-center align-items-center"
  style="height: 8vh"
></ws-loading-indicator>
<div *ngIf="!isLoading" class="container mt-5">
  <div class="row g-5">
    <!--Info-->
    <div class="col-md-6">
      <h4 class="text-center fw-bold">Your <u>Demo</u> Account will expire:</h4>
      <h4 class="text-danger text-center fw-bold">
        {{ expirationDate | date : "MM/dd/yyyy" }}
      </h4>
      <p>
        Thank you for exploring our service! You’re on a demo account, which
        provides you with time-limited full access to all the features Personnel
        Pulse has to offer!
      </p>
      <p>
        Purchase a subscription today to continue enjoying great features such
        as:
      </p>
      <ul class="blue-bullets">
        <li class="mb-1">
          <span class="fw-bold">Enhanced Efficiency: </span>Automate your shift
          scheduling needs, saving time by reducing manual work and minimizing
          errors.
        </li>
        <li class="mb-1">
          <span class="fw-bold">Optimized Workforce Allocation: </span>Personnel
          Pulse helps ensure the proper staff with the appropriate
          qualifications are assigned to each shift, improving productivity and
          ensuring compliance.
        </li>
        <li class="mb-1">
          <span class="fw-bold">Real-Time Updates: </span>Instant notifications
          and updates keep everyone informed of schedule changes, reducing
          miscommunication.
        </li>
        <li class="mb-1">
          <span class="fw-bold">Improved Staff Satisfaction: </span>Staff
          can easily view, manage, and request changes to their schedules,
          increasing their engagement and satisfaction.
        </li>
        <li class="mb-1">
          <span class="fw-bold">Cost Control: </span>Better shift management
          helps avoid overstaffing or understaffing, leading to more effective
          use of resources and reduced labor costs.
        </li>
        <li class="mb-1">
          <span class="fw-bold">Compliance and Record-Keeping: </span
          >Automatically track hours worked and other compliance-related data,
          ensuring adherence to labor laws and regulations.
        </li>
        <li class="mb-1">
          <span class="fw-bold">Scalability: </span>As your company grows,
          Personnel Pulse can easily scale to accommodate more staff and
          more complex scheduling needs.
        </li>
        <li class="mb-1">
          <span class="fw-bold">Reduced Absenteeism: </span>Automated reminders
          and easy shift swaps help reduce no-shows and last-minute absences.
        </li>
        <li class="mb-1">
          <span class="fw-bold">Increased Transparency: </span>Everyone has
          access to the same schedule information, fostering transparency and
          accountability.
        </li>
      </ul>
      <p>
        Getting started is easy — just contact our Sales team. They’ll guide you
        through the subscription process and answer any questions you have.
      </p>
    </div>
    <!--Contact Us-->
    <div class="col-md-6">
      <div class="card text-dark bg-light border-primary">
        <div
          class="card-header text-light bg-primary"
          style="text-align: center; font-weight: bold"
        >
          Contact Us
        </div>
        <div class="card-body p-4">
          <div class="mb-3">
            <h3>Sales Team</h3>
            <p>
              If you would like to purchase a Personnel Pulse subscription or
              have any questions, feel free to contact our Sales team:
            </p>
            <ul>
              <li>
                Email:
                <a href="mailto:sales@personnelpulse.com"
                  >sales&#64;personnelpulse.com</a
                >
              </li>
              <li>Phone: +1 (724) 755-3080</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--Contact Us Form-->
    <!-- <div class="col-md-6">
      <div class="card text-dark bg-light border-primary">
        <div
          class="card-header text-light bg-primary"
          style="text-align: center; font-weight: bold"
        >
          Contact Us
        </div>
        <div class="card-body">
          <div class="mb-3">
            <h5 class="card-title">Interested in a subscription purchase?</h5>
            <p class="card-text">
              Fill out the following form and a member of our team will reach
              out to you!
            </p>
          </div>
          <div [formGroup]="contactUsDemoForm">
            <div class="row mb-3">
              <div class="col">
                <app-form-label
                  [isRequired]="true"
                  labelText="First Name"
                ></app-form-label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="firstName"
                  placeholder="First Name..."
                />
              </div>
              <div class="col">
                <app-form-label
                  [isRequired]="true"
                  labelText="Last Name"
                ></app-form-label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="lastName"
                  placeholder="Last Name..."
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <app-form-label
                  [isRequired]="true"
                  labelText="Email Address"
                ></app-form-label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="firstName"
                  placeholder="Email Address..."
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <app-form-label
                  [isRequired]="true"
                  labelText="Phone Number"
                ></app-form-label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="phoneNumber"
                  placeholder="Phone Number..."
                />
              </div>
              <div class="col">
                <app-form-label
                  [isRequired]="true"
                  labelText="Company Name"
                ></app-form-label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="companyName"
                  placeholder="Company Name..."
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <button
                  class="btn btn-success ms-auto d-block"
                  (click)="onSubmitClicked()"
                  [disabled]="contactUsDemoForm.invalid"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>
